import { render, staticRenderFns } from "./mygooru.vue?vue&type=template&id=2472ee37&scoped=true"
import script from "./mygooru.ts?vue&type=script&lang=ts&external"
export * from "./mygooru.ts?vue&type=script&lang=ts&external"
import style0 from "./mygooru.scss?vue&type=style&index=0&id=2472ee37&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472ee37",
  null
  
)

export default component.exports